{{ 'application.environment-hint' | translate: { stage } }}
